import { Component, EventEmitter, Output } from '@angular/core';
import { NavService } from 'src/app/core/services/nav.service';

@Component({
  selector: 'globot-name-bot-step',
  template: `
    <div class="grid layout">
      <div class="col-12">
        <h1 style="text-align: center;margin-top:2rem;  font-weight: 700;font-family: sans-serif;">
          Nombre del asistente
        </h1>
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <p class="text-description">
          Dale a tu asistente un nombre propio, <b>podrás cambiarlo después si lo prefieres.</b>
        </p>
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <div class="form-name">
          <p style="font-weight: 700;margin-bottom:0;">Nombre</p>
          <input
            pInputText
            placeholder="Ej: Sofía"
            id="username"
            aria-describedby="username-help"
            [(ngModel)]="botName"
            (click)="botName = ''"
            autocomplete="off"
          />
          <p style="font-size: 14px; margin: 0rem; color: red;" *ngIf="showError">
            El nombre es requerido
          </p>
        </div>
      </div>

      <div
        style="position: absolute; bottom: 1vh; left: 25px;"
        *ngIf="!isMobile"
        [ngStyle]="isMobile ? { width: 'calc(50% - 20px)' } : { width: 'auto' }"
      >
        <globot-button
          [text]="'Volver'"
          width="w-auto"
          [icon]="'pi pi-arrow-left'"
          [iconPosition]="'left'"
          [styleClass]="'secondary'"
          (clickEvent)="back()"
        ></globot-button>
      </div>
      <div
        style="position: absolute; bottom: 1vh; right: 25px; text-align: right;"
        *ngIf="!isMobile"
      >
        <globot-button
          [text]="'Siguiente'"
          width="w-auto"
          [icon]="'pi pi-arrow-right'"
          [iconPosition]="'right'"
          (clickEvent)="saveName()"
        ></globot-button>
      </div>

      <div
        style="position: absolute; bottom: 10px; left: 10px; width: calc(50% - 20px);"
        *ngIf="isMobile"
      >
        <globot-button
          [text]="'Volver'"
          width="w-100"
          [icon]="'pi pi-arrow-left'"
          [iconPosition]="'left'"
          [styleClass]="'secondary'"
          (clickEvent)="back()"
        ></globot-button>
      </div>
      <div
        style="position: absolute; bottom: 10px; right: 10px; width: calc(50% - 20px); text-align: right;"
        *ngIf="isMobile"
      >
        <globot-button
          [text]="'Siguiente'"
          width="w-100"
          [icon]="'pi pi-arrow-right'"
          [iconPosition]="'right'"
          (clickEvent)="saveName()"
        ></globot-button>
      </div>
    </div>
  `,
  styleUrls: ['./name-bot-step.component.scss'],
})
export class NameBotStepComponent {
  @Output() nextEvent = new EventEmitter<void>();
  @Output() backEvent = new EventEmitter<void>();
  @Output() botNameEvent = new EventEmitter<string>();

  botName: string = '';
  showError: boolean = false;
  isMobile: boolean = window.innerWidth < 768;

  constructor(private navService: NavService) {
    //Auto generated name bot initial value bot
    let data = this.navService.getData();
    if (undefined !== data && null !== data) {
      this.botName = data.botName;
    } else {
      this.botName = `globot-${Math.floor(Math.random() * 1000)}`;
    }

    this.botNameEvent.emit(this.botName);
  }

  next(): void {
    this.nextEvent.emit();
  }

  saveName() {
    if (this.botName === '') {
      this.showError = true;
      return;
    }
    this.botNameEvent.emit(this.botName);

    this.navService.setData({ botName: this.botName });

    this.next();
  }

  back(): void {
    this.backEvent.emit();
  }
}
